import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./Teams.scss";
import moment from "moment/dist/moment";
import HomeGetStart from "@Components/Home/HomeGetStart/HomeGetStart";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown"
import YouTube from '@u-wave/react-youtube';
import getVideoId from 'get-video-id';
import {ImageModule} from "@Components/common/Image_Module"
// import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import NoImage from "../../utils/noImage"

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const items = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.3
    }
  }
}

const FilterGallery = (props) => {
  const [videoId, setVideoId] = useState('');
  const [showVideo, setShowVideo] = useState(false);
  const [videoindex, setVideoindex] = useState(null);
  const playVideo = (id, Embed_Video_URL) => {
    var videoid = getVideoId(Embed_Video_URL);
    setShowVideo(true)
    setVideoindex(id)
    setVideoId(videoid.id)
  }
  const closePlay = () => {
    setShowVideo(false)
    setVideoId('')
    setVideoindex(null)
  }
  const trackerVideo = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Video Play Btn',
      'formType': event,
      'formId': 'Video Play',
      'formName': 'Video',
      'formLabel': 'Video'
    });
  }
  const data = useStaticQuery(graphql`
    query{
      glstrapi {
        teams(sort:"Sort:ASC", publicationState: LIVE, where: {Publish: true}) {
            id
            imagetransforms
            ggfx_results {
              id
              content_type
              transforms
              src_import_url
              src_cftle
              field
            }
            Name
            Designation
            Video_Url
            URL
            Image {
              alternativeText
              url
            }
            offices {
                Office_Name
              }
          }
      }
    }
    `);
  const [teams, setTeams] = useState(data.glstrapi?.teams)
  const [filter, setFilter] = useState("All")
  const clickFilter = (e) => {
    setFilter(e)
  }
  const names = [...new Set(data.glstrapi.teams.map(c => c.offices.map(d => d.Office_Name)).flat())];
  const ImageRender = ({ alt, image_url, node, ggfx_results }) => {
    return (
      <ImageModule ImageSrc={image_url} attr={{ alt: alt }} ggfx_results={ggfx_results} imagename="team.Image.tail" strapi_id={node.id} />
      // <ImageTransform imagesources={image_url} renderer="srcSet" imagename="team.Image.tail" attr={{ alt: alt, class: '' }} imagetransformresult={processedImages} id={node.id} />
    )
  }

  return (
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.section
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <React.Fragment>
            <section className="teams-section">
              <Container>
                <Row>
                  <Col lg={12}>
                    <div className="content-how-can-we-help">
                      <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                        <h2><span className="stroke-text">{props.Title}</span>{props.Sub_Title}</h2></ScrollAnimation>
                      <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                        <ReactMarkdown source={props.Content} allowDangerousHtml />
                      </ScrollAnimation>

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="fiter-teams-categories">

                      <ul>
                        <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                          <li onClick={() => clickFilter('All')} className={filter === "All" ? "all-news active-category list-tab" : "all-news list-tab"}>All People <span className="teams-number">{teams?.length}</span></li>
                        </ScrollAnimation>
                        {names.map(list => (
                          <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                            <li onClick={() => clickFilter(list)} className={filter === list ? "active-category list-tab" : "list-tab"}>{list} <span className="teams-number">{teams.filter(d => d.offices.map(c => c.Office_Name).includes(list))?.length}</span></li>
                          </ScrollAnimation>
                        ))
                        }


                      </ul>

                    </div>
                  </Col>
                </Row>
                <Row className="filter-item-rows">

                  {filter === "All" ?
                    teams.map((item, index) => {
                      let processedImages = JSON.stringify({});
                      if (item?.imagetransforms?.Image_Transforms) {
                        processedImages = item.imagetransforms.Image_Transforms;
                      }
                      return (
                        <motion.div className="team-card" variants={items}>
                          {showVideo && videoindex === index && <div onClick={(e) => { closePlay(e) }} className="close-iframe-btn"></div>}
                          <div className="team-card-content">
                            <Link to={item.URL}>
                              <h6>{item.Name}</h6>
                              <span className="designation">{item.Designation}</span>
                            </Link>
                          </div>
                          <div className="item-image-wrrapper img-hover-zoom">
                            {showVideo && videoindex === index &&
                              <YouTube
                                video={videoId}
                                autoplay
                                showRelatedVideos={false}
                                showInfo={false}
                                annotations={false}
                                onEnd={e => { closePlay(e) }}
                                modestBranding={1}
                                onPlaying={trackerVideo(item?.Name)}

                              />
                            }
                            <Link to={item.URL}>
                              {/* <picture>
                                <source media="(min-width:992px)" srcSet={item.Image?.url} />
                                <source media="(min-width:768px)" srcSet={item.Image?.url} />
                                <img src={item.Image?.url} alt={item.Image?.alternativeText} />
                              </picture> */}
                              {/* <ImageTransform imagesources={item?.Image?.url} renderer="srcSet" imagename='team.Image.tail'
                              attr={{ alt: item.Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={item.id} >

                            </ImageTransform> */}
                            {item?.Image && item?.Image?.url ?
                            <ImageRender alt={item?.Name} processedImages={processedImages} image_url={item?.Image} node={item} ggfx_results={item.ggfx_results}  />
                            : <NoImage/>}
                            </Link>
                            {item.Video_Url &&
                              <span onClick={(e) => {
                                playVideo(index, item.Video_Url);
                              }} className="video-btn"><i class="icon-video"></i></span>
                            }
                          </div>
                        </motion.div>
                      );
                    })
                    :

                    teams.filter(list => list.offices.map(c => c.Office_Name).includes(filter)).map((item, index) => {
                      let processedImages = JSON.stringify({});
                      if (item?.imagetransforms?.Image_Transforms) {
                        processedImages = item.imagetransforms.Image_Transforms;
                      }
                      return (
                        <motion.div className="team-card" variants={items}>
                          {showVideo && videoindex === index && <div onClick={(e) => { closePlay(e) }} className="close-iframe-btn"></div>}
                          <Link to={item.URL}>

                            <div className="team-card-content">
                              <h6>{item.Name}</h6>
                              <span className="designation">{item.Designation}</span>
                            </div>
                          </Link>
                          <div className="item-image-wrrapper img-hover-zoom">
                            {showVideo && videoindex === index &&
                              <YouTube
                                video={videoId}
                                autoplay
                                showRelatedVideos={false}
                                showInfo={false}
                                annotations={false}
                                onEnd={e => { closePlay(e) }}
                                modestBranding={1}
                                onPlaying={trackerVideo(item?.Name)}

                              />
                            }
                            <Link to={item.URL}>
                              {/* <picture>
                                <source media="(min-width:992px)" srcSet={item.Image?.url} />
                                <source media="(min-width:768px)" srcSet={item.Image?.url} />
                                <img src={item.Image?.url} alt="" />
                              </picture> */}
                              {/* <ImageTransform imagesources={item?.Image?.url} renderer="srcSet" imagename='team.Image.tail'
                              attr={{ alt: item.Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={item.id} >

                            </ImageTransform> */}
                            {item?.Image && item?.Image?.url ?
                            <ImageRender alt={item?.Name} processedImages={processedImages} image_url={item?.Image} node={item} ggfx_results={item.ggfx_results}  />
                            : <NoImage/>}
                            </Link>
                            {item.Video_Url &&
                              <span onClick={(e) => {
                                playVideo(index, item.Video_Url);
                              }} className="video-btn"><i class="icon-video"></i></span>
                            }
                          </div>
                        </motion.div>);
                    })}
                </Row>
              </Container>
            </section>
            <HomeGetStart nobanner={true} />
          </React.Fragment>
        </motion.section>
      )}
    </InView>
  )
}

export default FilterGallery;